<template>
    <b-modal ref="modal" centered :visible="true" @hidden="hide">
        <template slot="modal-header">
            {{ Translations.sections.dayTemplates.details.schedule.modals.scheduleItem.title}}{{ " : " + (scheduledItem ||{}).name }}
        </template>
        <template>
            <div>
                <template v-if="scheduledItem.clockUid">
                    <h4>Available time intervals</h4>
                    <ul>
                        <li v-for="(free,index ) in availableZones" :class="['free',{'selected':free.isSelected}]" :for="'zone_'+index">
                            <input :id="'zone_'+index" type="radio" :value="free" v-model="selectedArea" name="freezone" @click="updateDraft(free)" />
                            <label :for="'zone_'+index">
                                <span>{{ minToMoment(free.minuteFrom).format("HH:mm") }}</span>
                                <span>&nbsp;-&nbsp;</span>
                                <span>{{ minToMoment(free.minuteTo).format("HH:mm") }}</span>
                            </label>
                        </li>
                    </ul>
                    <hr />
                    <h4>Time interval</h4>
                </template>
                <div class="config-row">
                    <label>From </label>
                    <TimeInput @onValueChanged="onStartChanged"
                               :initialValue="minToMoment(draft.minuteFrom)"
                               :format="'HH:mm'"></TimeInput>
                </div>
                <div class="config-row" v-if="scheduledItem.clockUid">
                    <label>To </label>
                    <TimeInput @onValueChanged="onEndChanged" :initialValue="minToMoment(draft.minuteTo)" :format="'HH:mm'">
                    </TimeInput>
                </div>
                <div v-if="scheduledItem.repeat != null" class="config-row">
                    <label for="toggle-repeat">Repeat</label>
                    <span class="input">
                        <ToggleInput id="toggle-repeat" :originalValue="draft.repeat" @onValueChanged="onRepeatChanged"></ToggleInput>
                    </span>
                </div>
                <transition name="fade" mode="out-in">
                    <div v-show="(scheduledItem.repeat != null && draft.repeat === true)">
                        <div class="config-row">
                            <label>Repeat Count </label>
                            <IntegerInput :defaultValue=1 :value="draft.repeatCount" @onValueChanged="onRepeatCountChanged" />
                        </div>
                        <div class="config-row">
                            <label>Repeat Delay (minutes)</label>
                            <IntegerInput :defaultValue=60 :value="draft.repeatDelay" @onValueChanged="onRepeatDelayChanged" :minValue="5" :maxValue="720" />
                        </div>
                    </div>
                </transition>
                <div v-if="errors">
                    <div class="text-danger" v-for="error in errors">
                        {{ error }}<br />
                    </div>
                </div>
            </div>
        </template>
        <template slot="modal-footer">
            <Button :empty="true" class="close-popup" @click.prevent="hide">{{ Translations.buttons.cancel }} </Button>
            <Button :empty="false" class="validate" @click.prevent.stop="onSave">{{ Translations.buttons.save }} </Button>
        </template>
    </b-modal>
</template>
<script>

    import { HTTP } from '@/utils/http';
    import Bootstrap from 'bootstrap-vue';
    import router from '@/router';
    import Button from'@/components/common/Button'
    import store from '@/store';
    import Translations from '@/store/translations';
    import { mapState } from 'vuex';
    import ScheduledItemTypes from '../../apis/_enums'
    import Apis from '@/apis/index'

    import Portlet from '@/components/common/Portlet.vue'
    import TimeInput from'@/components/common/TimeInput.vue'
    import IntegerInput from'@/components/common/IntegerInput.vue'
    import ToggleInput from'@/components/common/ToggleInput.vue'

    export default {
        name: "ScheduledItemEditionCard",
        store, router,
        props: {
            scheduledItem: { type: Object, required: true },
            scheduledItems: {
                type: Object, default: {}
            }
        },
        components: { Portlet, Bootstrap, Button, TimeInput, ToggleInput, IntegerInput },
        computed: {
            ...mapState(['currentStation']),
            Translations: function () { return Translations; },
            errorMessages: function (inputName) {
                if (this.apiResponse == null || this.apiResponse.errors == null) return [];
            },
            errors() {
                if (!this.apiResponse) return []
                var errors = new Set((this.apiResponse.errors || []).map(error => error.message));
                return Array.from(errors);
            },
            postData() {
                var postData = Object.assign({}, this.draft);
                postData.from = this.minToMoment(this.draft.minuteFrom).format("HH:mm:ss");
                postData.to = this.minToMoment(this.draft.minuteTo).format("HH:mm:ss");
                postData.minuteFrom = parseInt(postData.minuteFrom);
                postData.minuteTo = parseInt(postData.minuteTo);
                postData.minuteTo = postData.minuteTo == 0 ? 1440 : postData.minuteTo;
                return postData;
            },
            currentApi() {
                const types = ScheduledItemTypes.ScheduledItemTypes;
                switch ((this.draft || {}).typeId) {
                    case types.DAYTEMPLATE_CLOCK.value: return Apis.daytemplates.linkClock;
                    case types.DAYTEMPLATE_PLAYLIST.value: return Apis.daytemplates.linkPlaylist;
                    case types.DAYTEMPLATE_PODCAST.value: return Apis.daytemplates.linkPodcast;
                    case types.DAYTEMPLATE_PROMO.value: return Apis.daytemplates.linkPromo;
                    default: return null;
                }
            },
            availableZones() {
                // console.clear()
                // console.log("Process free tz")
                var clocks = ((this.scheduledItems || {}).clocks || []).sort(function (clA, clB) {
                    return clA.minuteFrom - clB.minuteFrom;
                });
                var freeZones = [];

                var tmpZone = { minuteFrom: 0, minuteTo: 1440, isSelected: false };
                for (var i = 0; i < clocks.length; i++) {
                    var tmpClock = clocks[i];
                    tmpZone.minuteTo = tmpClock.minuteFrom;

                    if (tmpZone.minuteTo > tmpZone.minuteFrom) {
                        freeZones.push(tmpZone);
                    }
                    // Add the zone of the currentClock
                    if (tmpClock.recordUid == this.scheduledItem.recordUid) {
                        var currentZone = {
                            minuteFrom: tmpClock.minuteFrom,
                            minuteTo: tmpClock.minuteTo,
                        };
                        if (!this.selected) {
                            currentZone.isSelected = true;
                        }
                        this.selected = true;
                        freeZones.push(currentZone);
                        this.selectedArea = currentZone;
                    }
                    tmpZone = {
                        minuteFrom: tmpClock.minuteTo
                        , minuteTo: 1440
                        , isSelected: false
                    }
                }
                var lastZone = freeZones[freeZones.length - 1];

                if (lastZone == null && tmpZone.minuteFrom < 1439) {
                    lastZone = tmpZone;
                    freeZones.push(tmpZone)
                }

                // Create last freezone
                if (tmpZone.minuteFrom < 1439 && (!lastZone || lastZone.minuteFrom != tmpZone.minuteFrom)) {
                    freeZones.push({ minuteFrom: tmpZone.minuteFrom, minuteTo: 1440 })
                }
                // AutoSelect
                if (!this.selected && this.draft && this.draft.autoSelect && freeZones.length > 0) {
                    this.selectedArea = freeZones[0];
                    this.selectedArea.isSelected = true;
                    this.updateDraft(this.selectedArea);
                    this.draft.autoSelect = false;
                }
                return freeZones;
            }
        },
        watch: {
            'scheduledItem': function (to, from) { }
        },
        data() {
            var workingCopy = Object.assign({
                originalMinuteFrom: this.scheduledItem.minuteFrom,
                originalMinuteTo: this.scheduledItem.minuteTo,
            }, this.scheduledItem);
            workingCopy.stationUid = this.$route.params.stationUid;
            workingCopy.dayTemplateUid = this.$route.params.dayTemplateUid;
            // Enable repeat by default
            workingCopy.repeat = true
            return {
                modalState: {
                    show: true,
                    visible: true,
                },
                stationUid: this.$store.state.currentStationUid,
                draft: workingCopy,
                selectedArea: null,
                apiResponse: null,
                activeZone: null,
                selected: false
            }
        }
        , methods: {
            onStartChanged(value) {
                this.draft.minuteFrom = value.hours() * 60 + value.minutes();
            },
            onEndChanged(value) {
                this.draft.minuteTo = value.hours() * 60 + value.minutes();
            },
            onRepeatChanged(value) {
                if (!value) {
                    this.onRepeatDelayChanged(0)
                    this.onRepeatCountChanged(0)
                }
                this.onValueChanged(this.draft, 'repeat', value)
            },
            onRepeatCountChanged(value) {
                this.onValueChanged(this.draft, 'repeatCount', value)
            },
            onRepeatDelayChanged(value) {
                this.onValueChanged(this.draft, 'repeatDelay', value)
            },
            onValueChanged(item, property, newValue) {
                item[property] = newValue;
            },
            updateDraft(newValue) {
                var newData = {
                    minuteFrom: parseInt(newValue.minuteFrom),
                    minuteTo: parseInt(newValue.minuteTo)
                }
                if (newData.minuteTo == 0) newData.minuteTo = 1440;
                this.draft = Object.assign(this.draft, newData)

            },
            onSave() {
                HTTP.post(this.currentApi, this.postData)
                    .then(this.onApiSaved, this.onApiError)
            },
            onApiSaved(response) {
                this.apiResponse = response.data.dataItem;

                if (Object.keys(this.apiResponse).length) {
                    store.dispatch('loadStationDayTemplates', this.stationUid);
                    this.$emit('onScheduledItemEdited');
                    this.hide();
                }
            },
            onApiError(error) {
                this.apiResponse = error.response.data;
            },
            show() { this.$refs['modal'].show() },
            hide() { this.$refs['modal'].hide(); this.$emit("onCancel"); },
        }
    }
</script>
<style lang="scss">
    ul {
        list-style: none;
        margin: 0;
        padding: 0;
    }

        ul li {
            padding: 5px 0;
            height: 40px;
            display: flex;
            align-content: center;
            align-items: center;
            cursor: pointer;
        }

            ul li.free:hover {
                font-weight: 600;
                cursor: pointer;
            }

            ul li.free label {
                margin: 0;
                cursor: pointer;
                flex-grow: 1;
                line-height: 40px;
            }

    div.time-area {
        display: flex;
        justify-content: space-between;
    }

    div.config-row {
        justify-content: space-between;
        display: flex;
        align-content: center;
        align-items: center;
    }


        div.config-row label {
            margin: 0;
            font-weight: 600;
        }

        div.config-row input, div.config-row .input {
            width: calc(3.5em + 10px);
            cursor: pointer;
            margin-left: 20px;
            margin-right: 20px;
            padding-left: 5px;
            padding-right: 5px;
            text-align: center;
        }

        div.config-row > div {
            align-items: center;
            display: flex;
            height: 40px;
        }

            div.config-row > div span {
                flex-grow: 1;
            }

    ul li input[type=radio] {
        cursor: pointer;
        margin-right: 10px;
    }
</style>
